/**
 * @ngdoc service
 * @name components.constant:localeSupported
 *
 * @description
 *
 */

angular
    .module('festzelt-os.components')
    .value('localeSupported', [
        'en-US'
    ]);



// WEBPACK FOOTER //
// ./src/app/components/values/locale-supported-value.js